module.exports = __webpack_public_path__ + "static/media/cosmetics.6bc400d6.png";